<script setup lang="ts">
  import { RouterView, useRoute } from 'vue-router';
  const $route = useRoute();
  import {onMounted} from 'vue';
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
  onMounted(() => {

    if (isMobile) {
      document.getElementById('app').style['min-width'] = '375px'; // 设置移动端样式
    }
  });
</script>

<template>
  <meta name="apple-mobile-web-app-capable" content="yes" />
  <meta
    name="viewport"
    content="width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"
  />
  <span style="position: absolute; left: 0; top: 0; opacity: 0">
    <span style="font-family: HanSans">1</span> <span style="font-family: HanSerif">1</span>
  </span>
  <router-view v-slot="{Component}">
    <keep-alive>
      <component :is="Component"/>
    </keep-alive>
  </router-view>
<!--  <RouterView />-->
</template>

<style lang="scss">
  @font-face {
    font-family: 'HanSans'; /* 字体名称 */
    src: url('./assets/fonts/SourceHanSansCN-Normal.otf') format('opentype'); /* 字体文件路径 */
    /* 可以添加其他字体格式的引入，例如woff2、ttf等 */
  }
  @font-face {
    font-family: 'HanSerif'; /* 字体名称 */
    src: url('./assets/fonts/SourceHanSerifSC-Medium.otf') format('opentype'); /* 字体文件路径 */
    /* 可以添加其他字体格式的引入，例如woff2、ttf等 */
  }
  @import './assets/iconfont/iconfont.css';
  @import './styles/common.scss';

  #app {
    min-width: 1200px;
    min-height: 100vh;
    font-size: 14px;
    color: #333;
    background-color: #fafafa;
  }
  .btn-primary{
    background: #1c6cff!important;
  }
</style>
